import React, { useContext } from 'react';
import { Formik, Form } from 'formik';
import {
  Button,
  Row,
  Col,
  RequiredStar
} from '@youngcapital/component-library';
import PropTypes from 'prop-types';
import withTranslation from '../helpers/withTranslation';
import { AppContext } from '../../AppContext';

const SignupForm = ({
  t,
  initialValues,
  validationSchema,
  children,
  onSubmit,
  formValidationError
}) => {
  const { pages, currentPageIndex } = useContext(AppContext);
  const isLastPage = currentPageIndex === pages.length - 1;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {form => {
        const hasValidationError = () => {
          const { isValid } = form;
          return !isValid ? formValidationError() : undefined;
        };

        return (
          <Form noValidate>
            {children(form)}
            <Row>
              <Col xs={12} md={6} className='pb-2x pt-1x flex-row'>
                <RequiredStar color className='mr-1x' />
                <p>{t('form.required')}</p>
              </Col>
              <Col xs={12} md={6} className='text--right'>
                <Button
                  variant='primary'
                  type='submit'
                  loading={form.isSubmitting}
                  onClick={hasValidationError}
                  data-cy='submit'
                >
                  {isLastPage ? t('form.button_submit') : t('form.button_next')}
                </Button>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

SignupForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  validationSchema: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  formValidationError: PropTypes.func.isRequired
};

export default withTranslation()(SignupForm);
